import { render, staticRenderFns } from "./homepage.vue?vue&type=template&id=a768ecd2&scoped=true"
import script from "./homepage.vue?vue&type=script&lang=js"
export * from "./homepage.vue?vue&type=script&lang=js"
import style0 from "./homepage.vue?vue&type=style&index=0&id=a768ecd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a768ecd2",
  null
  
)

export default component.exports